
import { signOut } from 'aws-amplify/auth';
import log from 'loglevel';
import { memo } from 'react';

import { btnDanger, btnMd } from '../styles/tw-components';

const stylesheet = {
    button: `${btnDanger} ${btnMd} tw:text-white`,
};

async function handleSignOutClick() {
    try {
        await signOut({ global: true });
        window.location.assign('/signIn');
    } catch (err) {
        log.error(err);
    }
}

function SignOutButton(/* props */) {
    return (
        <button
          type="button"
          className={stylesheet.button}
          name="signOut"
          onClick={handleSignOutClick}
        >
            Sign Out
        </button>
    );
}

export default memo(SignOutButton);
